/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TemperatureScales {
    Celsius = 0,
    Fahrenheit = 1,
    Kelvin = 2,
}
